import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './login.reducer';
import { ILoginState } from './login.reducer';

const getLoginState = createFeatureSelector<ILoginState>('login');
const selectFeature = getLoginState;
export const getLoginData = createSelector(selectFeature, state => state.federatedLoginData);
export const getResendVerifyEmailActionState = createSelector(
  getLoginState,
  fromReducer.getResendVerifyEmailActionState
);
